import React from 'react';
import { Card, Typography, Tooltip } from 'antd';
import { CloseCircleOutlined, VideoCameraOutlined } from '@ant-design/icons';

const { Text } = Typography;
const VideoFailedPlaceholder = ({ error, isCustomerMessage }) => {
	return (
		<Card
			size="small"
			bordered={false}
			bodyStyle={{ padding: 0 }}
			style={{
				width: '100%',
				maxWidth: 300,
				borderRadius: 8,
				background: isCustomerMessage ? '#f0f2f5' : '#ffeceb',
				overflow: 'hidden'
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					padding: 12,
					minHeight: 160,
					gap: 8,
					background: 'transparent'
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					<VideoCameraOutlined style={{ fontSize: 20, color: '#ff4d4f' }} />
					<CloseCircleOutlined style={{ fontSize: 20, color: '#ff4d4f' }} />
				</div>
				<Text style={{ fontWeight: 600, color: '#cf1322' }}>Video failed to process</Text>
				{error && (
					<Tooltip title={error}>
						<Text style={{
							textAlign: 'center',
							color: 'rgba(0, 0, 0, 0.65)',
							fontSize: 12,
							maxWidth: 260
						}} ellipsis>
							{error}
						</Text>
					</Tooltip>
				)}
				<Text style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 11 }}>Try a smaller video file</Text>
			</div>
		</Card>
	);
};

export default VideoFailedPlaceholder;


